import React from 'react';
import PropTypes from 'prop-types';
import startCase from 'lodash/startCase';
import cx from 'classnames';

import UserModel from 'models/user';

const propTypes = {
  user: PropTypes.instanceOf(UserModel).isRequired,
  serviceName: PropTypes.string.isRequired,
  serviceURL: PropTypes.string,
  onLink: PropTypes.func.isRequired,
  onUnlink: PropTypes.func.isRequired,
};

const defaultProps = {
  serviceURL: null,
};

const Service = ({ user, onLink, onUnlink, serviceName, serviceURL }) => {
  let status;
  if (!(user && user.authorizedServices.get(serviceName))) {
    let link;
    if (serviceURL) {
      link = (
        <a
          className="btn btn-block btn-cutout btn-md"
          onClick={onLink}
          href={serviceURL}
        >
          LINK &amp; SAVE
        </a>
      );
    } else {
      link = (
        <div
          className="btn btn-block btn-cutout btn-md"
          onClick={onLink}
        >
          LINK &amp; SAVE
        </div>
      );
    }

    status = <div className="connection-status">{link}</div>;
  } else {
    status = (
      <div className="connection-status">
        <div className="text-weight-light"><span className="iconified-font iconified-checkmark-circle text-color-dark-slate" /> Linked</div>
        <div className="text-weight-light"><a onClick={onUnlink}>{`Unlink ${startCase(serviceName)}`}</a></div>
      </div>
    );
  }

  const iconClasses = cx({
    'iconified-font': serviceName === 'concur',
    'iconified': serviceName === 'expensify',
    'h1-sg': serviceName === 'concur',
    'text-color-concur-blue': serviceName === 'concur',
    'align-bottom': true,
  });

  return (
    <div className="row">
      <div className="col-xs-3 col-md-1 col-md-offset-1 padding-left-0-gte-md">
        <div className={`${iconClasses} iconified-${serviceName}`} />
      </div>
      <div className="col-xs-9 col-md-7 padding-left-0">
        <div className="h6-sg text-color-dark-slate line-height-extra">{`Link to ${startCase(serviceName)}`}</div>
        <div className="text-weight-light">{`Link all business bookings to ${startCase(serviceName)}.`}</div>
      </div>
      <div className="col-xs-9 col-xs-offset-3 col-md-3 col-md-offset-0 padding-left-0-xs text-right-md">
        { status }
      </div>
    </div>
  );
};

Service.propTypes = propTypes;
Service.defaultProps = defaultProps;

export default Service;
